module.exports = __webpack_public_path__ + "static/img/230_TO8_1975_og.7defa12.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/230_TO8_1975_og.jpg
// module id = MnHp
// module chunks = 0